export function onContentLoaded(onLoad, args) {
  return new Promise(resolve => {
    // `DOMContentLoaded` may fire before your script has a chance to run, so check before adding a listener
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', async () => {
        await onLoad(args);
        resolve();
      });
    } else {
      // `DOMContentLoaded` already fired
      onLoad(args);
      resolve();
    }
  });
}
